import AidexacxAssistantAPI from 'dashboard/api/aidexacx/assistant';
import { createStore } from '../storeFactory';

export default createStore({
  name: 'AidexacxAssistant',
  API: AidexacxAssistantAPI,
});
